class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
    this.init();
  }

  init() {
    this.carousel = new Swiper(this.querySelector('.swiper'), {
      spaceBetween: 20,
      slidesPerView: 1,
      navigation: {
        prevEl: this.querySelector('.swiper-arrow--prev'),
        nextEl: this.querySelector('.swiper-arrow--next'),
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        dynamicBullets: true,
      },
    });
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    const activeMediaId = this.openedBy.getAttribute('data-media-id');
    const mediaFound = Array.from(
      this.querySelectorAll('[data-media-id]'),
    ).find((media) => media.dataset.mediaId === activeMediaId);

    if (!mediaFound) return;

    this.carousel.slideTo(Number(mediaFound.dataset.index));
  }
}

customElements.define('product-modal', ProductModal);
